import { render, staticRenderFns } from "./PainterChat.vue?vue&type=template&id=32aeace0&scoped=true"
import script from "./PainterChat.vue?vue&type=script&lang=js"
export * from "./PainterChat.vue?vue&type=script&lang=js"
import style0 from "./PainterChat.vue?vue&type=style&index=0&id=32aeace0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aeace0",
  null
  
)

export default component.exports